/* pc-cart-guard.js: moved out of snippets/preorder-cart-guard.liquid inline script (Page Weight, Oct 2026). */
(function () {
  if (window.__pcCartGuardJs) return;
  window.__pcCartGuardJs = true;
(function () {
  if (window.__pcCartGuard) return;
  window.__pcCartGuard = true;

  var MAP_URL = (window.__pcCartGuardCfg || {}).mapUrl || '/collections/pre-order-cart-guard?view=pc-map';
  var ADD_TITLE = 'Cannot Add Item to Cart';
  var ADD_MSG = 'Orders With Pre-Order Items Cannot be Combined with In-Stock Items or Pre-Order Items with a Different Release Date';
  var CHECKOUT_TITLE = 'Please Update Your Cart';
  var CHECKOUT_MSG = ADD_MSG + '. Please remove items so your cart contains only in-stock items, or only pre-order items with the same release date.';
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var POLICY_URL = ((window.__pcCartGuardCfg || {}).policyUrl || '/pages/pre-order-policy');
  var AGREE_ATTR = 'Pre-Order Policy';

  var _fetch = window.fetch ? window.fetch.bind(window) : null;
  var mapPromise = null;

  function getMap() {
    if (!mapPromise) {
      mapPromise = _fetch(MAP_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.v ? j.v : null; })
        .catch(function () { return null; });
    }
    return mapPromise;
  }
  // Cart is cached so the check before an add needs no network round trip (keeps Add to Cart fast).
  var cartCache = null, cartAt = 0;
  function getCart() {
    return _fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCache = c; cartAt = Date.now(); return c; });
  }
  function getCartFast() {
    return (cartCache && Date.now() - cartAt < 30000) ? Promise.resolve(cartCache) : getCart();
  }
  function isCartWriteUrl(url) { return /\/cart\/(add|change|update|clear)(\.js)?$/.test(pathOf(url)); }
  function keyOf(map, variantId) {
    var d = map[String(variantId)];
    return d ? 'pre:' + d : 'stock';
  }
  function paid(line) { return line.final_line_price > 0; }
  function cartKeys(map, cart) {
    var keys = [];
    (cart.items || []).forEach(function (l) {
      if (!paid(l)) return;
      var k = keyOf(map, l.variant_id);
      if (keys.indexOf(k) < 0) keys.push(k);
    });
    return keys;
  }
  // existing: keys already in cart; adding: keys being added
  function conflicts(existing, adding) {
    var uniqAdd = [];
    adding.forEach(function (k) { if (uniqAdd.indexOf(k) < 0) uniqAdd.push(k); });
    if (uniqAdd.length > 1) return true;
    if (!existing.length || !uniqAdd.length) return false;
    return uniqAdd.some(function (k) { return existing.indexOf(k) < 0; });
  }
  function describe(keys) {
    var parts = keys.map(function (k) {
      if (k === 'stock') return 'in-stock items';
      var d = k.slice(4);
      if (d.indexOf('nodate-') === 0) return 'a pre-order item';
      var p = d.split('-');
      return 'pre-order items releasing ' + MON[+p[1] - 1] + ' ' + (+p[2]) + ', ' + p[0];
    });
    return parts.join(' and ');
  }

  function pathOf(url) {
    try { return new URL(url, location.href).pathname; } catch (e) { return ''; }
  }
  function isAddUrl(url) { return /\/cart\/add(\.js)?$/.test(pathOf(url)); }

  // Pull [{id, qty}] out of whatever body an add-to-cart request uses.
  function addsFromBody(body) {
    var out = [];
    function push(id, q) { if (id) out.push({ id: String(id), qty: parseInt(q, 10) || 1 }); }
    function fromParams(get, entries) {
      if (get('id')) push(get('id'), get('quantity'));
      var items = {};
      entries.forEach(function (e) {
        var m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(e[0]);
        if (m) { items[m[1]] = items[m[1]] || {}; items[m[1]][m[2]] = e[1]; }
      });
      Object.keys(items).forEach(function (i) { push(items[i].id, items[i].quantity); });
    }
    try {
      if (!body) return out;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        fromParams(function (k) { return body.get(k); }, Array.from(body.entries()));
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        fromParams(function (k) { return body.get(k); }, Array.from(body.entries()));
      } else if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{') {
          var j = JSON.parse(s);
          if (j.id) push(j.id, j.quantity);
          (j.items || []).forEach(function (it) { push(it.id, it.quantity); });
        } else {
          var sp = new URLSearchParams(s);
          fromParams(function (k) { return sp.get(k); }, Array.from(sp.entries()));
        }
      }
    } catch (e) {}
    return out;
  }

  // Compare carts before/after an add; return lines whose newly added paid units break the rule.
  function violations(map, before, after) {
    var prev = {};
    (before.items || []).forEach(function (l) { prev[l.key] = l.quantity; });
    var existing = cartKeys(map, before);
    var added = [];
    (after.items || []).forEach(function (l) {
      var was = prev[l.key] || 0;
      if (l.quantity > was && paid(l)) added.push({ line: l, was: was, key: keyOf(map, l.variant_id) });
    });
    if (!added.length) return [];
    return conflicts(existing, added.map(function (a) { return a.key; })) ? added : [];
  }
  function revert(bad) {
    return bad.reduce(function (p, a) {
      return p.then(function () {
        return _fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: a.line.key, quantity: a.was })
        });
      });
    }, Promise.resolve());
  }
  function blockedResponse() {
    return new Response(JSON.stringify({ status: 422, message: ADD_TITLE, description: ADD_MSG }), {
      status: 422, headers: { 'Content-Type': 'application/json' }
    });
  }

  /* ---------- popup ---------- */
  function showPopup(opts) {
    opts = opts || {};
    var old = document.getElementById('pcg-modal');
    if (old) old.remove();
    if (!document.getElementById('pcg-style')) {
      var st = document.createElement('style');
      st.id = 'pcg-style';
      st.textContent =
        '#pcg-modal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(17,24,39,.55)}' +
        '#pcg-modal .pcg-box{background:#fff;color:#111827;max-width:440px;width:100%;border-radius:14px;padding:26px 24px 22px;text-align:center;box-shadow:0 20px 50px rgba(0,0,0,.3);font-family:inherit}' +
        '#pcg-modal .pcg-icon{width:46px;height:46px;margin:0 auto 12px;border-radius:50%;background:#fee2e2;color:#dc2626;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:800;line-height:1}' +
        '#pcg-modal h2{margin:0 0 10px;font-size:20px;line-height:1.25;color:#111827}' +
        '#pcg-modal p{margin:0 0 10px;font-size:15px;line-height:1.5;color:#374151}' +
        '#pcg-modal .pcg-note{font-size:13px;color:#6b7280}' +
        '#pcg-modal .pcg-actions{display:flex;gap:10px;justify-content:center;margin-top:16px;flex-wrap:wrap}' +
        '#pcg-modal .pcg-btn{min-width:120px;padding:11px 18px;border-radius:8px;border:1px solid #111827;background:#111827;color:#fff;font:inherit;font-weight:700;cursor:pointer;text-decoration:none}' +
        '#pcg-modal .pcg-btn--ghost{background:#fff;color:#111827}';
      document.head.appendChild(st);
    }
    var m = document.createElement('div');
    m.id = 'pcg-modal';
    m.setAttribute('role', 'alertdialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', 'pcg-title');
    var box = document.createElement('div');
    box.className = 'pcg-box';
    var icon = document.createElement('div'); icon.className = 'pcg-icon'; icon.textContent = '!';
    var h = document.createElement('h2'); h.id = 'pcg-title'; h.textContent = opts.title || ADD_TITLE;
    var p = document.createElement('p'); p.textContent = opts.message || ADD_MSG;
    box.appendChild(icon); box.appendChild(h); box.appendChild(p);
    if (opts.note) { var n = document.createElement('p'); n.className = 'pcg-note'; n.textContent = opts.note; box.appendChild(n); }
    var actions = document.createElement('div'); actions.className = 'pcg-actions';
    if (opts.showCartLink) {
      var a = document.createElement('a'); a.className = 'pcg-btn pcg-btn--ghost'; a.href = '/cart'; a.textContent = 'View Cart';
      actions.appendChild(a);
    }
    var ok = document.createElement('button'); ok.type = 'button'; ok.className = 'pcg-btn'; ok.textContent = 'OK';
    actions.appendChild(ok); box.appendChild(actions); m.appendChild(box);
    function close() {
      m.remove(); document.removeEventListener('keydown', onKey, true);
      if (opts.reload) location.reload();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ok.addEventListener('click', close);
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', onKey, true);
    (document.body || document.documentElement).appendChild(m);
    ok.focus();
  }
  function showAddBlocked(existingKeys, reload) {
    showPopup({
      note: existingKeys && existingKeys.length ? 'Your cart currently has ' + describe(existingKeys) + '.' : '',
      showCartLink: true, reload: !!reload
    });
  }
  window.PokeCollectCartGuard = { show: showAddBlocked };

  if (!_fetch) return;

  /* ---------- 1. Add-to-cart forms: check before the add happens ---------- */
  var skipNextFetch = false;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !isAddUrl(f.getAttribute('action') || f.action || '')) return;
    if (f.__pcgOk) { f.__pcgOk = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    // a second tap while we're still checking is ignored, not queued (prevents double adds)
    if (f.__pcgBusy) return;
    var submitter = e.submitter;
    var adds = addsFromBody(new FormData(f));
    // show the theme's spinner right away, so the button never looks like it ignored the tap
    var host = f.closest('product-form') || f;
    var btn = (submitter && submitter.form === f) ? submitter : f.querySelector('[type="submit"]');
    var spin = host.querySelector('.loading-overlay__spinner');
    f.__pcgBusy = true;
    if (btn) btn.classList.add('loading');
    if (spin) spin.classList.remove('hidden');
    function idle() {
      f.__pcgBusy = false;
      if (btn) btn.classList.remove('loading');
      if (spin) spin.classList.add('hidden');
    }
    function proceed() {
      // Re-submit on a fresh task. When the check finishes instantly (data already cached) the browser
      // is still dispatching the original submit event and silently ignores a requestSubmit() made now:
      // that was swallowing every other Add to Cart click.
      setTimeout(function () {
        idle();
        f.__pcgOk = true;
        skipNextFetch = true;
        try {
          if (f.requestSubmit) {
            try { f.requestSubmit(submitter && submitter.form === f ? submitter : undefined); }
            catch (err) { f.requestSubmit(); }
          } else { f.submit(); }
        } finally {
          f.__pcgOk = false;   // never leave a stale pass behind
          skipNextFetch = false;
        }
      }, 0);
    }
    Promise.all([getMap(), getCartFast()]).then(function (r) {
      var map = r[0], cart = r[1];
      if (!map) return proceed();
      var existing = cartKeys(map, cart);
      if (conflicts(existing, adds.map(function (a) { return keyOf(map, a.id); }))) {
        idle();
        showAddBlocked(existing);
      } else { proceed(); }
    }).catch(proceed);
  }, true);

  /* ---------- 2. Any other add-to-cart (apps, quick-buy, upsells) via fetch ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input);
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method === 'POST' && isCartWriteUrl(url) && !isAddUrl(url)) {
      // quantity change / remove / discount: refresh the cached cart once it's done
      return _fetch(input, init).then(function (resp) { getCart().catch(function () {}); return resp; });
    }
    if (method !== 'POST' || !isAddUrl(url)) return _fetch(input, init);
    if (skipNextFetch) { skipNextFetch = false; return _fetch(input, init).then(function (resp) { getCart().catch(function () {}); return resp; }); }
    var parsedAdds = addsFromBody(init && init.body);
    if (parsedAdds.length) {
      // Fast path: decide from the cached cart, send the add right away, double-check in the background.
      return Promise.all([getMap(), getCartFast()]).then(function (r) {
        var map = r[0], before = r[1];
        if (!map) return _fetch(input, init);
        var existing = cartKeys(map, before);
        if (conflicts(existing, parsedAdds.map(function (a) { return keyOf(map, a.id); }))) {
          showAddBlocked(existing);
          return blockedResponse();
        }
        return _fetch(input, init).then(function (resp) {
          if (resp.ok) {
            getCart().then(function (after) {
              var bad = violations(map, before, after);
              if (bad.length) revert(bad).then(function () { getCart(); showAddBlocked(cartKeys(map, before), true); });
            }).catch(function () {});
          }
          return resp;
        });
      }, function () { return _fetch(input, init); });
    }
    return Promise.all([getMap(), getCart()]).then(function (r) {
      var map = r[0], before = r[1];
      if (!map) return _fetch(input, init);
      return _fetch(input, init).then(function (resp) {
        if (!resp.ok) return resp;
        return getCart().then(function (after) {
          var bad = violations(map, before, after);
          if (!bad.length) return resp;
          return revert(bad).then(function () {
            showAddBlocked(cartKeys(map, before));
            return blockedResponse();
          });
        });
      });
    }, function () { return _fetch(input, init); });
  };

  /* ---------- 3. Same for apps that use XMLHttpRequest ---------- */
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, async) {
    this.__pcgAdd = String(method).toUpperCase() === 'POST' && isAddUrl(url) && async !== false;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (!this.__pcgAdd) return _send.apply(this, arguments);
    var xhr = this, args = arguments;
    Promise.all([getMap(), getCart()]).then(function (r) {
      var map = r[0], before = r[1];
      if (map) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 400) return;
          getCart().then(function (after) {
            var bad = violations(map, before, after);
            if (bad.length) revert(bad).then(function () { showAddBlocked(cartKeys(map, before), true); });
          });
        });
      }
      _send.apply(xhr, args);
    }, function () { _send.apply(xhr, args); });
  };

  /* ---------- 4. Checkout: block a cart that is already mixed ---------- */
  function guardCheckout(e, resume, origin) {
    e.preventDefault();
    e.stopImmediatePropagation();
    Promise.all([getMap(), getCart()]).then(function (r) {
      var map = r[0], cart = r[1];
      var keys = map ? cartKeys(map, cart) : [];
      if (keys.length > 1) {
        showPopup({ title: CHECKOUT_TITLE, message: CHECKOUT_MSG, note: 'Your cart currently has ' + describe(keys) + '.' });
      } else if (map && hasPreorder(map, cart) && !agreed(cart)) {
        askAgreement(resume, origin);
      } else { resume(); }
    }).catch(resume);
  }

  /* ---------- 5. Pre-Order Policy agreement (required before checkout when the cart has a pre-order) ---------- */
  function hasPreorder(map, cart) { return cartKeys(map, cart).some(function (k) { return k.indexOf('pre:') === 0; }); }
  function agreed(cart) { return !!(cart && cart.attributes && /^Agreed/.test(cart.attributes[AGREE_ATTR] || '')); }
  function stamp() {
    try { return 'Agreed ' + new Date().toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }); } catch (e) { return 'Agreed ' + new Date().toISOString(); }
  }
  function saveAgreement(on) {
    var attrs = {}; attrs[AGREE_ATTR] = on ? stamp() : '';
    return _fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { return r.json(); }).then(function (c) { cartCache = c; cartAt = Date.now(); return c; });
  }
  function agreeStyle() {
    if (document.getElementById('pcpa-style')) return;
    var st = document.createElement('style'); st.id = 'pcpa-style';
    st.textContent =
      '.pcpa{margin:0 0 12px;padding:11px 13px;border:1px solid #c7d2fe;border-radius:12px;background:#eef2ff;color:#1f2937;text-align:left;font-size:13.5px;line-height:1.45;transition:box-shadow .2s,border-color .2s}' +
      '.pcpa[hidden]{display:none!important}' +
      '.pcpa label{display:flex;gap:10px;align-items:flex-start;cursor:pointer;margin:0}' +
      '.pcpa input{flex:none;width:18px;height:18px;margin:1px 0 0;accent-color:#3d5afe;cursor:pointer}' +
      '.pcpa a{color:#3d5afe;font-weight:800;text-decoration:underline}' +
      '.pcpa-msg{display:none;margin:6px 0 0 28px;color:#dc2626;font-size:12.5px;font-weight:700}' +
      '.pcpa.is-needed{border-color:#dc2626;box-shadow:0 0 0 3px rgba(220,38,38,.15);background:#fff5f5}' +
      '.pcpa.is-needed .pcpa-msg{display:block}' +
      '.pcpa.is-shake{animation:pcpaShake .35s}' +
      '@keyframes pcpaShake{0%,100%{transform:none}25%{transform:translateX(-5px)}75%{transform:translateX(5px)}}' +
      'body.pcpa-need .additional-checkout-buttons,body.pcpa-need .cart__dynamic-checkout-buttons{display:none!important}' +
      '#pcg-modal .pcpa{margin:14px 0 0}' +
      '#PcMiniCart .pcpa{margin:0 0 10px;padding:9px 11px;font-size:12.5px;border-radius:10px}#PcMiniCart .pcpa input{width:16px;height:16px}#PcMiniCart .pcpa-msg{margin-left:26px;font-size:12px}';
    document.head.appendChild(st);
  }
  function agreeBox() {
    var box = document.createElement('div'); box.className = 'pcpa'; box.setAttribute('data-pcpa', '');
    box.innerHTML = '<label><input type="checkbox" data-pcpa-check><span>I have read and agree to the terms of the <a target="_blank" rel="noopener"></a></span></label>' +
      '<p class="pcpa-msg" role="alert">Please Agree to the Pre-Order Policy to Continue.</p>';
    var a = box.querySelector('a'); a.href = POLICY_URL; a.textContent = 'Pre-Order Policy';
    return box;
  }
  var agreeState = { need: false, on: false };
  function paintAgreement() {
    document.body && document.body.classList.toggle('pcpa-need', agreeState.need && !agreeState.on);
    document.querySelectorAll('[data-pcpa]').forEach(function (b) {
      b.hidden = !agreeState.need;
      var c = b.querySelector('[data-pcpa-check]'); if (c) c.checked = agreeState.on;
      if (agreeState.on) b.classList.remove('is-needed');
    });
  }
  // put the checkbox above every Checkout button in the cart drawer and on the cart page
  function mountAgreement() {
    agreeStyle();
    document.querySelectorAll('#CartDrawer-Checkout, [name="checkout"], #PcMiniCart a[href$="/checkout"]').forEach(function (btn) {
      if (btn.closest('#pcg-modal')) return;
      var host = btn.closest('.cart__ctas, .pcmc-btns') || btn.parentElement; if (!host || !host.parentElement) return;
      var prev = host.previousElementSibling;
      if (prev && prev.hasAttribute && prev.hasAttribute('data-pcpa')) return;
      host.parentElement.insertBefore(agreeBox(), host);
    });
    paintAgreement();
  }
  var refreshT = null;
  function refreshAgreement() {
    clearTimeout(refreshT);
    refreshT = setTimeout(function () {
      Promise.all([getMap(), getCart()]).then(function (r) {
        var map = r[0], cart = r[1];
        agreeState.need = !!(map && hasPreorder(map, cart));
        agreeState.on = agreed(cart);
        // no pre-orders left: drop an old agreement so a future pre-order asks again
        if (!agreeState.need && agreeState.on) { agreeState.on = false; saveAgreement(false).catch(function () {}); }
        mountAgreement();
      }).catch(function () {});
    }, 120);
  }
  // when the shopper has to agree outside the cart (e.g. the pop-up's Checkout link)
  function onScreen(el) {
    if (!el || el.hidden) return false;
    var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
    if (!r.width || !r.height || cs.visibility === 'hidden' || +cs.opacity === 0) return false;
    if (r.bottom < 0 || r.top > innerHeight || r.right < 0 || r.left > innerWidth) return false;
    var drawer = el.closest('cart-drawer');
    if (drawer && !(drawer.classList.contains('active') || drawer.classList.contains('animate') || drawer.hasAttribute('open'))) {
      var hit = document.elementFromPoint(Math.min(innerWidth - 1, Math.max(0, r.left + 10)), Math.min(innerHeight - 1, Math.max(0, r.top + 10)));
      if (!hit || !el.contains(hit)) return false;
    }
    return true;
  }
  function nearbyBox(origin) {
    for (var n = origin, i = 0; n && n !== document.body && i < 6; n = n.parentElement, i++) {
      var b = n.querySelector && n.querySelector('[data-pcpa]');
      if (b) return onScreen(b) ? b : null;
    }
    return null;
  }
  function askAgreement(resume, origin) {
    var inline = nearbyBox(origin);
    agreeState.need = true; paintAgreement();
    if (inline) {
      inline.hidden = false; inline.classList.add('is-needed', 'is-shake');
      setTimeout(function () { inline.classList.remove('is-shake'); }, 400);
      inline.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    showPopup({ title: 'Pre-Order Policy', message: 'Your cart has a pre-order item. Please agree to the Pre-Order Policy before checking out.' });
    var m = document.getElementById('pcg-modal'); if (!m) return;
    var box = agreeBox(); var p = m.querySelector('.pcg-box > p'); p.parentNode.insertBefore(box, p.nextSibling);
    var ok = m.querySelector('.pcg-actions .pcg-btn'); ok.textContent = 'Continue to Checkout'; ok.disabled = true; ok.style.opacity = '.5';
    var c = box.querySelector('[data-pcpa-check]');
    c.addEventListener('change', function () { ok.disabled = !c.checked; ok.style.opacity = c.checked ? '' : '.5'; });
    ok.addEventListener('click', function () {
      if (!c.checked) return;
      saveAgreement(true).then(function () { agreeState.on = true; paintAgreement(); resume(); }, resume);
    });
  }
  document.addEventListener('change', function (e) {
    var c = e.target; if (!c || !c.matches || !c.matches('[data-pcpa-check]') || c.closest('#pcg-modal')) return;
    agreeState.on = c.checked; paintAgreement();
    saveAgreement(c.checked).catch(function () {});
  });
  ['afterCartChanged', 'afterUpdateQuantity', 'cart:refresh', 'cart-drawer:open'].forEach(function (t) { document.addEventListener(t, refreshAgreement); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAgreement); else refreshAgreement();
  if (window.MutationObserver) {
    // the drawer re-renders its contents after every change; put the checkbox back when it does
    var moT = null;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && (t.closest('cart-drawer') || t.closest('#main-cart-footer, cart-items, .cart__footer'))) { clearTimeout(moT); moT = setTimeout(refreshAgreement, 60); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t || t.__pcgOk) return;
    guardCheckout(e, function () {
      t.__pcgOk = true;
      t.click();
      setTimeout(function () { t.__pcgOk = false; }, 1500);
    }, t);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || f.__pcgOk) return;
    var path = pathOf(f.getAttribute('action') || f.action || '');
    var toCheckout = /\/checkout$/.test(path) ||
      (/\/cart$/.test(path) && ((e.submitter && e.submitter.name === 'checkout') || f.querySelector('input[name="checkout"]')));
    if (!toCheckout) return;
    var submitter = e.submitter;
    guardCheckout(e, function () {
      setTimeout(function () {
        f.__pcgOk = true;
        if (submitter && submitter.name === 'checkout' && f.requestSubmit) f.requestSubmit(submitter);
        else f.submit();
        setTimeout(function () { f.__pcgOk = false; }, 1500);
      }, 0);
    }, submitter || f);
  }, true);

  // Warm the data feed early so the first add doesn't wait on the network:
  // shortly after the page loads, and again the moment a shopper reaches for any Add to Cart button.
  function warm() { getMap(); getCartFast().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(warm, 200); });
  else setTimeout(warm, 200);
  var ATC = '[name="add"], .product-form__submit, [data-holo-atc], [data-plush-atc], [data-pr-add], [data-pcr-add], [data-quick-add], .quick-add__submit';
  ['pointerdown', 'touchstart', 'mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target && e.target.closest && e.target.closest(ATC)) warm();
    }, { capture: true, passive: true });
  });
})();
})();
